import { createSelector } from '@reduxjs/toolkit';
import {DeleteIcon, EditIcon} from 'evergreen-ui';
import { dcpcApi } from './dcpcApi';
import {tags} from "./tags";

const {
  CREATE_PROGRAM_BLOCK_TAG,
  DELETE_PROGRAM_BLOCK_TAG,
} = tags;

export const DEVICE_TYPES_TAG = 'DeviceTypes';
dcpcApi.enhanceEndpoints({ addTagTypes: [DEVICE_TYPES_TAG] });
const api = dcpcApi.injectEndpoints({
  endpoints: (builder) => ({

    getDeviceTypes: builder.query({
      query: () => 'device-types',
      providesTags: [DEVICE_TYPES_TAG],
    }),
    getDeviceType: builder.query({
      query: (id) => `device-types/${id}`,
      providesTags: [DEVICE_TYPES_TAG],
    }),
    getDeviceTypeWithProgram: builder.query({
      query: (id) => `device-types/${id}/program`,
      providesTags: [DEVICE_TYPES_TAG],
    }),
    getProgramBlocksByDeviceTypeId: builder.query({
      query: (id) => `device-types/${id}/program-blocks`,
      providesTags: [DEVICE_TYPES_TAG, CREATE_PROGRAM_BLOCK_TAG, DELETE_PROGRAM_BLOCK_TAG],
    }),
    createDeviceType: builder.mutation({
      query: (args) => ({
        url: 'device-types',
        method: 'POST',
        body: args,
      }),
      invalidatesTags: [DEVICE_TYPES_TAG],
    }),
    updateDeviceType: builder.mutation({
      query: (args) => ({
        url: `device-types/${args.id}`,
        method: 'PUT',
        body: args,
      }),
      invalidatesTags: [DEVICE_TYPES_TAG],
    }),
    deleteDeviceType: builder.mutation({
      query: (id) => ({
        url: `device-types/${id}`,
        method: 'DELETE',
        // providesTags: [DEVICE_TYPES_TAG],
        invalidateTags: [DEVICE_TYPES_TAG],
      }),
    }),

  }),
});

export const {
  useGetProgramBlocksByDeviceTypeIdQuery,
  useGetDeviceTypesQuery,
  useGetDeviceTypeQuery,
  useCreateDeviceTypeMutation,
  useUpdateDeviceTypeMutation,
  useDeleteDeviceTypeMutation,
  useGetDeviceTypeWithProgramQuery,
} = api;

export const deviceTypesSelect = (state) => api.endpoints.getDeviceTypes.select()(state);
export const deviceTypesSelector = (state) => deviceTypesSelect(state)?.data || [];

export const filterDeviceTypesBySearchTextSelector = createSelector(
  deviceTypesSelector,
  (_, searchText) => searchText,
  (deviceTypes, searchText) => ({
    columns: [
      {
        label: 'Наименование',
      },
      {
        label: 'Короткое наименование',
      },
      {
        label: 'Код',
      },
      {
        label: 'Производитель',
      },
    ],
    rows: deviceTypes.reduce((acc, cur) => {
      const {
        id, kod, fullName, shortName, manufacturer, // проверка на наличие UNIT
      } = cur;
      const row = [id, fullName, shortName, kod, manufacturer ? manufacturer.name : ''].map((v) => v || '');
      if (row.filter((v, idx) => idx !== 0 && v !== null && v.toUpperCase().includes(searchText.toUpperCase())).length > 0) {
        acc.push(row);
      }
      return acc;
    }, []),
    rowButtons: [
      {
        label: 'Редактировать датчик',
        to: (id) => `${id}`, // переход на форму редактирования
        icon: EditIcon,
      },
      {
        label: 'Редактировать разделы датчика',
        to: (id) => `${id}/program-blocks`,
        icon: EditIcon,
      },
      {
        label: 'Удалить',
        // to: () => {},
        intent: 'danger',
        type: 'delete',
        icon: DeleteIcon,
      },
    ],
  }),
);
export const deviceTypesBySearchTextSelector = (searchText) => (state) => filterDeviceTypesBySearchTextSelector(state, searchText);
